import { PublicHoliday } from "@models/public-holiday"
import { Term } from "@models/term"
import { MonthViewDay } from "calendar-utils"

export class CalendarStore {
  constructor(
    public terms: Term[] = [],
    public editableTerm: Term = new Term(),
    public editablePublicHoliday: PublicHoliday = new PublicHoliday(),
    public activeDay: MonthViewDay = null,
  ) {}
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/calendar.ts